module.exports = __webpack_public_path__ + "static/media/emperorPenguin.8e7e9770.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/emperorPenguin.jpg
// module id = 112
// module chunks = 0